import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../api/services/auth.service';

export const TransactionGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const actionType = Number(route.queryParamMap.get('actionType'));

  if (authService.hasActiveSubscription || actionType === 4) return true;

  return router.createUrlTree(['/wallet'], { queryParams: { returnUrl: state.url } });
};
